import * as types from 'stores/types';

export function setActiveAccount( account ) {
  return { type: types.SET_ACTIVE_ACCOUNT, account };
}

export function openPhoneCallModal( phone ) {
  return { type: types.OPEN_PHONE_CALL_MODAL, phone };
}

export function hangUpCall() {
  return { type: types.HANG_UP_CALL };
}

export function loadChannel( id ) {
  return { type: types.LOAD_CHANNEL, id };
}

export function reloadChannelsList() {
  return { type: types.RELOAD_CHANNELS_LIST };
}

export function reloadChatsList() {
  return { type: types.RELOAD_CHATS_LIST };
}



// WEBPACK FOOTER //
// ./stores/actions/common/channelDetail.js